import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] text-white">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="h-20 md:h-24 overflow-hidden -ml-2">
              <img
                src={BRAND.logoWhite}
                alt="Velor Advisory logo — British-owned UAE consultancy"
                className="h-[280px] md:h-[320px] w-auto -mt-[100px] md:-mt-[118px] object-contain"
                draggable="false"
              />
            </div>
            <p className="mt-6 text-white/60 max-w-md font-light leading-relaxed">
              British-owned UAE consultancy delivering concierge-grade visa, residency
              and business setup services from the heart of Dubai.
            </p>
            <div className="mt-10 flex gap-4">
              <a href={BRAND.calendly} target="_blank" rel="noreferrer" data-testid="footer-book-btn" className="inline-flex items-center px-6 py-4 text-[11px] tracking-overline uppercase bg-white text-black hover:bg-white/85 transition-colors">
                Book a Consultation
              </a>
              <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-btn" className="inline-flex items-center px-6 py-4 text-[11px] tracking-overline uppercase border border-white/30 hover:border-white transition-colors">
                WhatsApp
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-overline uppercase text-white/45 mb-5">Navigate</div>
            <ul className="space-y-3 text-sm text-white/75 font-light">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-white transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-overline uppercase text-white/45 mb-5">Services</div>
            <ul className="space-y-3 text-sm text-white/75 font-light">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>{s.title}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-overline uppercase text-white/45 mb-5">Contact</div>
            <ul className="space-y-4 text-sm text-white/75 font-light">
              <li className="flex items-start gap-3"><MapPin size={15} className="mt-0.5 text-white/60" /><span>{BRAND.addressShort}</span></li>
              <li className="flex items-start gap-3"><Mail size={15} className="mt-0.5 text-white/60" /><a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="hover:text-white">{BRAND.email}</a></li>
              <li className="flex items-start gap-3"><Phone size={15} className="mt-0.5 text-white/60" /><a href={`tel:${BRAND.whatsapp.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="hover:text-white">{BRAND.whatsapp}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center text-xs text-white/45 font-light">
          <div>© {new Date().getFullYear()} Velor Advisory. All rights reserved.</div>
          <div className="flex gap-6">
            <span>United Arab Emirates</span>
            <span>British-Owned & Managed</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
